/*global cb, $, location */
/*
    Name: AuditsService.js
    Author: Jing Zhang
    Description: service module for Global Options Audit History Service calls
*/
import axios from 'axios';
import _ from 'lodash';
import DomainNameAPI from '../constants/DomainNameAPI';
import ContentLookup from '../constants/ContentLookup';
import Constants from '../constants/Constants';
import Topics from '../constants/Topics';
const variEnv = process.env.REACT_APP_STAGE;
const audits_base_url = DomainNameAPI[variEnv].AUDITS_SERVICE_BASEURL;
import LoginService from '../utils/login-service';
import React from 'react';
import ReactDOM from 'react-dom';

const apiError = Constants.API_SERVER_ERROR;

export let getAudits = async (argsObject) => {
  if (_.isNil(argsObject.Api) || _.isNil(argsObject.orgId) || _.isNil(argsObject.years))
    throw new Error('getAudits call requires that Api, orgId, or year CANNOT be undefined or null');

  if (!LoginService.getTokens().isLoggedIn) {
    argsObject.Api.log('getAudits is called when user is not logged in');
    throw new Error('getAudits is called when user is not logged in');
  }
  let dataAudits = [],
    timeOptions = {
      hour12: true,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    };
  argsObject.Api.Publish(Topics.IS_LOADING, { isLoading: true });
  for (let year of argsObject.years) {
    let TARGET_AUDITS_SERVICE_URL =
      audits_base_url +
      'orgId=' +
      argsObject.orgId +
      '&application=' +
      argsObject.clientId +
      '&year=' +
      year +
      '&createOptions=true';
    //console.log('TARGET_AUDITS_SERVICE_URL::', TARGET_AUDITS_SERVICE_URL);

    try {
      let response = await axios({
        method: 'GET',
        url: TARGET_AUDITS_SERVICE_URL,
        timeout: 15000,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CB-Catapult-Authentication-Token': 'CBLogin ' + cb.core.iam.getAuthSession().sessionId,
          'X-CB-Catapult-Authorization-Token': LoginService.getTokens().token,
        },
      });
      // Mapping data contents if needed
      response && response.data ? (response.data = ContentLookup(response.data, year)) : [];
      response && response.data
        ? response.data.map((element) => {
          element.times = new Date(element.timestamp).toLocaleTimeString('en-US', timeOptions);
        })
        : [];
        
      let auditDataYear = { year: year, auditItems: response.data ? response.data : [] };
      dataAudits.push(auditDataYear);
      //console.log('Audits response.data:: ', dataAudits);
    } catch (error) {
      argsObject.Api.log('calling getAudits() failed ', error);
      argsObject.Api.Publish(Topics.API_ERROR, { apiError: true });
    }
  }
  argsObject.Api.Publish(Topics.AUDITS_DATA, dataAudits);
  argsObject.Api.Publish(Topics.IS_LOADING, { isLoading: false });
};

const showError = (error) => {
  const errorMessage = error;
  ReactDOM.render(
    <div className="Error" style={{ color: 'black' }}>
      <h4>
        {errorMessage && (
          <div style={{ color: 'black' }} className="error">
            {' '}
            {errorMessage}{' '}
          </div>
        )}
      </h4>
    </div>,
    document.getElementById('root')
  );
};
